// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"644":"2528fe10","782":"54211574","861":"54211574","910":"ea1d32bb"}[chunkId] + ".chunk.css";
};